// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1131":"b6c58fe7","9232":"7e3f65a2"}[chunkId] + ".chunk.css";
};